import { Response } from '@marketplace-web/core-api/api-client-util'
import { transformCurrencyAmountDto } from '@marketplace-web/domain/currency-data'

import {
  BumpOrderDto,
  BumpOrderItemDto,
  BumpOrderItemModel,
  BumpOrderModel,
  PrepareBumpOrderResp,
} from '../types/bump-order'

export const transformBumpOrderItem = (dto: BumpOrderItemDto): BumpOrderItemModel => ({
  itemId: dto.item_id,
  title: dto.title,
  imageUrl: dto.image_url,
  total: transformCurrencyAmountDto(dto.total),
  payable: transformCurrencyAmountDto(dto.payable),
  discount: transformCurrencyAmountDto(dto.discount),
  discounted: transformCurrencyAmountDto(dto.discounted),
})

export const transformBumpOrderItems = (
  dtos: Array<BumpOrderItemDto> = [],
): Array<BumpOrderItemModel> => dtos.map(transformBumpOrderItem)

export const transformBumpUpOrder = (dto: BumpOrderDto): BumpOrderModel => ({
  id: dto.id,
  status: dto.status,
  freeCount: dto.free_count,
  totalCount: dto.total_count,
  total: transformCurrencyAmountDto(dto.total),
  payIn: transformCurrencyAmountDto(dto.pay_in),
  payable: transformCurrencyAmountDto(dto.payable),
  discount: transformCurrencyAmountDto(dto.discount),
  discounted: transformCurrencyAmountDto(dto.discounted),
  freePushUpsValue: transformCurrencyAmountDto(dto.free_push_ups_value),
  discountPercentage: dto.discount_percentage,
  pushUpOrderItems: transformBumpOrderItems(dto.push_up_order_items),
  salesTax: dto.sales_tax ? transformCurrencyAmountDto(dto.sales_tax) : null,
  isTaxCoverageAvailable: dto.tax_coverage_available ?? null,
  isTaxCovered: dto.tax_covered ?? null,
})

export const transformPrepareBumpOrderResponse = (response: Response<PrepareBumpOrderResp>) =>
  transformBumpUpOrder(response.push_up_order)
